// form
import { FormProvider as Form } from 'react-hook-form';

// ----------------------------------------------------------------------


export default function FormProvider({ children, onSubmit = undefined, methods }) {
  return (
    <Form {...methods}>
      <form onSubmit={onSubmit}>{children}</form>
    </Form>
  );
}
